<template>
    <div class="collections-deposition frame-outline px-5 py-4 my-4">
        <div class="deposition-quote text-size-5">
            <p v-for="paragraph in deposition.text">{{ paragraph }}</p>
            <div
                v-if="deposition.video"
                class="pos-relative aspect aspect-xs-16-9 bg-default-1 rounded overflow-hidden"
            >
                <video
                    class="lazy lazy-fade pos-absolute pos-all w-full h-full"
                    controls
                    height="240"
                    width="320"
                >
                    <source
                        :data-src="`${$scope.CDN_IMAGES}${deposition.video}`"
                        type="video/mp4"
                    />
                </video>
            </div>
            <p class="text-bold text-right">
                –&nbsp;{{ deposition.author || deposition.name }}
                <span v-if="deposition.author && deposition.name"> ({{ deposition.name }}) </span>
            </p>
            <div class="quote-open" />
            <div class="quote-close" />
        </div>
        <div class="text-center mt">
            <a
                v-if="deposition.productsLink"
                :href="deposition.productsLink"
                class="btn btn-primary"
                target="_blank"
            >
                Veja o catálogo
            </a>
        </div>
    </div>
</template>

<script>
    import { updateLazyLoad } from '../../../../common/common';

    export default {
        name: 'PartnersPageDeposition',

        props: ['deposition'],

        mounted() {
            updateLazyLoad();
        },
    };
</script>
